export default __webpack_public_path__ + "static/media/cnp20_2.e445aa79.png";